import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCaseSensitive = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M5.724 6.295c-.208.375-.435.96-.77 1.827l-.996 2.583h3.89l-.996-2.583c-.334-.868-.561-1.452-.769-1.827a1.5 1.5 0 0 0-.18-.27 1.5 1.5 0 0 0-.18.27Zm.23-.315s-.003.003-.009.005zm-.092.005q-.009-.004-.009-.005 0-.002.009.005m2.485 6.011 1.111 2.883a.646.646 0 0 0 1.205-.465L8.038 7.608c-.31-.806-.569-1.476-.825-1.939-.245-.442-.634-.969-1.31-.969s-1.064.527-1.309.969c-.257.463-.515 1.133-.826 1.94l-.019.048-2.606 6.757a.646.646 0 1 0 1.205.465l1.112-2.883zm10.434 3.252c-.734.28-1.477-.402-1.88-1.012a3.229 3.229 0 1 1-.185-4.615.627.627 0 0 1 1.067.447v2.927c0 .551.447.998.998.998.357 0 .488 1.069 0 1.255m-2.253-3.242a1.974 1.974 0 1 0 0 .027z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCaseSensitive;
